import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

import logoOrange from '../../../assets/img/Logo-th.png';

import '../../../styles/frontend/Footer.css';

// const facebookUrl = 'https://www.facebook.com/eecwecan'
const facebookUrl = 'https://www.facebook.com/EECMDD'
// const youtubeUrl = 'https://www.youtube.com/@eecwecan'
const youtubeUrl = 'https://www.youtube.com/@eecmdd'

const Footer = () => {
  const navigate = useNavigate();
  return (
      // <Container className="py-5 d-flex flex-column ">
      //   <Row className="mb-4 text-center justify-content-center">

    <Container fluid className="footer-container text-white">
       <Container className="mt-4">
        <Row className="footer-top py-4">
          <Col md={6}>
            <img src={logoOrange} alt="EEC Footer Logo" className="footer-logo mb-4" style={{ objectFit: 'contain' }}/>
            {/* <img src="/images/img_footerlogo.png" alt="EEC Footer Logo" className="footer-logo mb-4" /> */}
            <p className="footer-phone">โทรศัพท์: +66 2033 8000 ต่อ 2091</p>
            <p className="footer-desc mt-2">
              สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.)<br />
              ชั้น 25 อาคารโทรคมนาคม บางรัก เลขที่ 72 ซอยวัดม่วงแค ถนนเจริญกรุง<br />
              แขวงบางรัก เขตบางรัก กรุงเทพมหานคร 10500<br />
              Email : mdd@eeco.or.th<br />
              เวลาทำการ: จันทร์ - ศุกร์ 09:00 - 17:00 น.
            </p>
            <Row className="footer-social justify-content-left mt-4 mb-3">
              <Col xs="auto">
                <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
                  <img src="/images/facebook.png" alt="FB" />
                </a>
              </Col>
              {/* <Col xs="auto"><img src="/images/img_group_indigo_900.svg" alt="IG" /></Col>
              <Col xs="auto"><img src="/images/img_group_indigo_900_40x40.svg" alt="X" /></Col> */}
              <Col xs="auto">
                <a href={youtubeUrl} target="_blank" rel="noopener noreferrer">
                  <img src="/images/youtube.png" alt="YouTube" />
                </a>
              </Col>
              {/* <Col xs="auto">
                  <img src="/images/img_group_1.svg" alt="LINE" />
              </Col> */}
          </Row>
            <p className="footer-copy">
              {/* Copyright © 2025 Eastern Economic Corridor (EEC) Office */}
              Copyright © 2025 Eastern Economic Corridor Office (EECO)
            </p>
          </Col>
          <Col md={2}>
            <p className="footer-qr-text">
              ช่องทางการตอบแบบวัด<br />
              การรับรู้ของผู้มีส่วนได้ส่วนเสียภายนอก (EEC)
            </p>
            {/* <img src="/images/img_qrita_1.png" alt="QR Code" className="footer-qr-img" /> */}
            <img src="/images/img_qr.png" alt="QR Code" className="footer-qr-img" />
          </Col>
          <Col md={4}>
            <h5 className="footer-menu-title text-white">เมนูระบบ</h5>
            <ul className="footer-menu-list">
              <li onClick={() => navigate('/homepage')}>หน้าหลัก</li>
              <li onClick={() => navigate('/data-center')}>EEC Model</li>
              <li onClick={() => navigate('/publicize')}>ประชาสัมพันธ์</li>
              {/* <li onClick={() => navigate('/homepage')}>หน้าหลัก</li> 
              <li onClick={() => navigate('/publicize')}>ประชาสัมพันธ์</li>
              <li onClick={() => navigate('/data-center')}>ศูนย์ข้อมูล</li> */}
            </ul>
          </Col>
        </Row>
      </Container>
        {/* <Row>
          <Col>
            <img src="/images/img_footer_1.png" alt="Footer Background" className="footer-bg w-100" />
          </Col>
        </Row> */}
        <Row>
          <Col>
            {/* <img src="/images/img-footer-blue.png" alt="Footer Background" className="footer-bg w-100" /> */}
            <img src="/images/img-footer-blue-full.png" alt="Footer Background" className="footer-bg w-100 h-100" />
          </Col>
        </Row>
    </Container>
  );
};

export default Footer;
